<div class="keylesson-container">
  <h1 fxLayout="row" fxLayoutAlign="center center" class="dark-gray">
    <i class="icon-lg light-blue ri-keyboard-line"></i> &nbsp;{{ 'KEYLESSON.LIST.TITLE' | translate }}
  </h1>

  <!-- tiles -->
  <div class="lessons-grid" fxLayout="row wrap">

    <div class="lesson-card" *ngFor="let lesson of keyLessons" fxFlex="25" [ngClass]="{'disabled': lesson.locked}" (click)="view(lesson)">
      <mat-card>      
        <img *ngIf="language === 'uk'" mat-card-image src="{{ 'assets/images/keylesson/' + lesson.id + '.png' }}">
        <img *ngIf="language === 'dk'" mat-card-image src="{{ 'assets/images/keylesson/' + lesson.id + '_dk.png' }}">
        <img *ngIf="language === 'de'" mat-card-image src="{{ 'assets/images/keylesson/' + lesson.id + '_de.png' }}">
        <mat-card-content>
          <p>{{ 'KEYLESSON.LESSON.NO' | translate: { value: lesson.id} }}</p>
        </mat-card-content>
      </mat-card>

      <!-- badge -->
      <div class="badge">
        <ng-content *ngTemplateOutlet="badge; context{ completed: lesson.completed, locked: lesson.locked }"></ng-content>
      </div>

    </div>

  </div>

</div>

<ng-template #badge let-completed="completed" let-locked="locked">

  <div [ngClass]="{
    'success-background': completed,
    'dark-gray-background': locked,
    'light-gray-background': !locked && !completed
  }">
    <i *ngIf="completed" class="icon-lg ri-check-line white"></i>

    <i *ngIf="locked" class="icon-lg ri-lock-fill white"></i>

    <i *ngIf="!locked && !completed" class="icon-lg ri-lock-unlock-fill"></i>
  </div>


</ng-template>